<template lang="pug">
  nav.mobile-navbar
    ul
      li
        router-link.router-link.mobile-navbar-option(:to='"/vacaciones"')
          i.fa.fa-plane
          span Mis vacaciones
      li
        router-link.router-link.mobile-navbar-option(:to='"/permisos"')
          i.fa.fa-history
          span Mis permisos
      li
        router-link.router-link.mobile-navbar-option(:to='"/boletas"')
          i.fa.fa-money
          span Mis boletas
      li(@click="toggleSidebar")
        .mobile-navbar-option
          i.fa.fa-bars
          span Opciones
</template>


<script>
export default {
  data () {
    return {
      perfilUsuario    : localStorage.getItem('perfilVacaciones'),
      empresa: process.env.EMPRESA
    };
  },
  computed: {
    showSidebarMobile () {
      return this.$store.getters.showSidebarMobile
    }
  },
  methods: {
    toggleSidebar () {
      this.$store.dispatch('setSidebarMobile', !this.showSidebarMobile)
    }
  }
};
</script>
<style lang="stylus" scoped>

.mobile-navbar
  bottom 0
  left 0
  width 100%
  background-color #fff
  box-shadow: 0px 0px 1px 1px #ccc
  // aqui va el tamaño del icono
  i
    font-size 25px
    margin-bottom: 2px
  span
    font-size 11px
    line-height: 11px

.mobile-navbar-option
  color: #4a4a4a
  border-radius 0px
  transition 0.2s padding ease
  display flex
  flex-direction: column
  height: 100%
  align-content: center
  justify-content: start
  padding-top: 7px


.mobile-navbar ul
  display flex
  height: 100%
  li
    flex 1





.router-link-active
  background-color: #565cde
  color: #fff
  .badge
    color #565cde


</style>



// WEBPACK FOOTER //
// Component_Bottom_Bar.vue?6f9e125a